import template from './product-detail-product-boxes-settings.html.twig';

const {Component} = Shopware;


Component.register('product-detail-product-boxes-settings', {
    template: template,

    inject: [
        'repositoryFactory',
        'TopdataPbProductExtensionApiService',
    ],

    data() {
        return {
            isLoading:                 false,
            isLoadingGroups:           false,
            availablePropertyGroups:   [], // <-- property groups that really occur on this product
            topdataPbProductExtension: null, // <-- this is the entity were the settings are stored, fetched from server
        };
    },

    computed: {
        product() {
            // SW 6.7: swProductDetail is a Pinia store
            const store = Shopware.Store.get('swProductDetail');
            return store ? store.product : null;
        },

        topdataPbProductExtensionRepository() {
            return this.repositoryFactory.create('topdata_pb_product_extension');
        },

        /**
         * dropdown options: the property groups occurring on this product, plus already
         * selected groups that no longer occur (marked in the label)
         */
        propertyGroupSelectOptions() {
            const absentLabel = this.$tc('TopdataProductBoxesSW6.productDetailSettings.absent');

            const options = this.availablePropertyGroups.map((group) => {
                return {
                    label: group.name,
                    value: group.id,
                };
            });

            const availableIds = this.availablePropertyGroups.map((group) => group.id);
            this._allSelectedEntries().forEach((entry) => {
                if (availableIds.includes(entry.id)) {
                    return;
                }

                options.push({
                    label: `${entry.name || entry.id} – ${absentLabel}`,
                    value: entry.id,
                });
            });

            return options;
        },

        /**
         * ids currently stored in the extension (the value of sw-multi-select)
         */
        selectedPropertyGroupIds() {
            return this._selectedIds('propertyGroups');
        },

        selectedDetailPropertyGroupIds() {
            return this._selectedIds('detailPropertyGroups');
        },
    },

    created() {
        if (!this.product || !this.product.id) {
            return;
        }

        this.loadAvailablePropertyGroups();
        this.loadProductExtension();
    },

    methods: {
        loadAvailablePropertyGroups() {
            this.isLoadingGroups = true;

            return this.TopdataPbProductExtensionApiService.getPropertyGroupsOfProduct(this.product.id).then((groups) => {
                this.availablePropertyGroups = groups || [];
                this.isLoadingGroups = false;
            }).catch(() => {
                this.availablePropertyGroups = [];
                this.isLoadingGroups = false;
            });
        },

        loadProductExtension() {
            const criteria = new Shopware.Data.Criteria();
            criteria.addAssociation('propertyGroupXrefs');
            criteria.getAssociation('propertyGroupXrefs').addSorting(Shopware.Data.Criteria.sort('position', 'ASC'));
            criteria.addAssociation('propertyGroupXrefs.propertyGroup');
            criteria.addFilter(Shopware.Data.Criteria.equals('productId', this.product.id));

            this.topdataPbProductExtensionRepository.search(criteria, Shopware.Context.api).then((result) => {
                const model = result.first();
                if (model) {
                    // ---- existing product extension (assign both selections before storing
                    //      the object, so the save watcher does not fire on load)
                    model.propertyGroups = this._groupsOfSlot(model, 'listing');
                    model.detailPropertyGroups = this._groupsOfSlot(model, 'detail');
                    this.topdataPbProductExtension = model;
                } else {
                    // ---- new product extension
                    this.topdataPbProductExtension = {
                        id:                    Shopware.Utils.createId(),
                        productId:             this.product.id,
                        propertyGroups:        [],
                        detailPropertyGroups:  [],
                    };
                }
            });
        },

        onPropertyGroupChange(ids) {
            this._applySelection('propertyGroups', ids);
        },

        onDetailPropertyGroupChange(ids) {
            this._applySelection('detailPropertyGroups', ids);
        },

        saveProductExtension() {
            this.isLoading = true;
            this.TopdataPbProductExtensionApiService.updateTopdataPbProductExtension(this.topdataPbProductExtension).then(() => {
                this.isLoading = false;
            });
        },

        _selectedIds(key) {
            if (!this.topdataPbProductExtension) {
                return [];
            }

            return (this.topdataPbProductExtension[key] || []).map((entry) => entry.id);
        },

        _allSelectedEntries() {
            if (!this.topdataPbProductExtension) {
                return [];
            }

            return [
                ...(this.topdataPbProductExtension.propertyGroups || []),
                ...(this.topdataPbProductExtension.detailPropertyGroups || []),
            ];
        },

        _groupsOfSlot(model, slot) {
            return (model.propertyGroupXrefs || [])
                .filter((xref) => xref.slot === slot && xref.propertyGroup)
                .map((xref) => {
                    return {
                        id:   xref.propertyGroup.id,
                        name: xref.propertyGroup.name,
                    };
                });
        },

        _applySelection(key, ids) {
            if (!this.topdataPbProductExtension) {
                return;
            }

            const nameById = {};
            this.availablePropertyGroups.forEach((group) => {
                nameById[group.id] = group.name;
            });
            this._allSelectedEntries().forEach((entry) => {
                nameById[entry.id] = entry.name || entry.id;
            });

            this.topdataPbProductExtension[key] = (ids || []).map((id) => {
                return {
                    id:   id,
                    name: nameById[id] || id,
                };
            });
        },
    },

    watch:   {
        topdataPbProductExtension: {
            handler(newValue, oldValue) {
                if (!oldValue) {
                    return;
                }
                this.saveProductExtension();
            },
            deep:      true,
            immediate: true,
        },
    },
});
